import React from "react";
import styles from "./EntitlementFieldLobbyResult.module.scss";
import { EntitlementResultType } from "types";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import Text from "components/text/Text";
import strings from "assets/strings";
//import strings from "assets/strings";
//import { getAllClassNames,  } from "helpers";
import  settings  from "assets/mergeSettings";

export const EntitlementFieldLobbyResult = ({ hit }: { hit: EntitlementResultType }) => {

  return (

    <a href={`${settings.zakautSubLobbyServicePage}?sid=${hit.serviceId}`} className={styles.link}>
      <div className={styles.entitlementDetails}>
        <Text
          className={styles.textServiceName}
          text={hit.serviceName}
        />
   <Text
  className={styles.textEntitlementDesc}
  text={hit.seviceDescClear?.replace(/\.\s+\.\s+\./g, '...').replace(/([.:])(?!\.)\s*(?=[^\s])/g, '$1 ').replace(/,(?=\s*\.*\s*$)/, '')}
/>
        <div className={styles.entitlementPrices}>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('sal') ? <SvgGenerator className={styles.svg} name="SalZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <Text
              className={hit.zakauts.hasOwnProperty('sal') ? styles.textEnable : styles.textDisable}
              text={strings.entitlementSearch.healthBasket}
            />
          </div>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('silver') ? <SvgGenerator className={styles.svg} name="SilverZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <Text
              className={hit.zakauts.hasOwnProperty('silver') ? styles.textEnable : styles.textDisable}
              text={strings.entitlementSearch.silverLeumit}
            />
          </div>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('golden') ? <SvgGenerator className={styles.svg} name="GoldZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <Text
              className={hit.zakauts.hasOwnProperty('golden') ? styles.textEnable : styles.textDisable}
              text={strings.entitlementSearch.goldLeumit}
            />
          </div>
        </div>
      </div>
    </a>

  );
};
